import { InteractiveItem } from '@/models/InteractiveItem'
import get from 'lodash/get'

function concatIfExists(data, key, suffix) {
  let value = get(data, key)
  return value ? value + suffix : ''
}

function mapAction(raw) {
  var actionType, subAction;
  switch (get(raw, 'action.type')) {
    case 'openMailto':
      actionType = 'openMailto'
      break
    case 'openLink':
      actionType = 'openLink'
      break
    case 'openDownload':
      actionType = 'openDownload'
      break
    case 'openVideo':
      actionType = 'openVideo'
      break
    case 'skipTo':
      actionType = 'controlPlayer'
      subAction = 'skipTo'
      break
    case 'skipToAndPause':
      actionType = 'controlPlayer'
      subAction = 'skipToAndPause'
      break
    case 'play':
      actionType = 'controlPlayer'
      subAction = 'play'
      break
    case 'pause':
      actionType = 'controlPlayer'
      subAction = 'pause'
      break
  }
  return { actionType, subAction };
}

function mapAreaType(raw) {
  return {
    'hotspot': 'hotspot',
    'image': 'image',
    'text': 'note',
    'playeraction': 'playeraction'
  }[get(raw, 'area.type')]
}

export default {
  map(raw) {
    var areaType = mapAreaType(raw);
    var { actionType, subAction } = mapAction(raw);

    return new InteractiveItem({
      meta: {
        name: raw.name,
        id: raw._id
      },
      start: raw.start,
      end: raw.end,
      style: {
        width: concatIfExists(raw, 'style.dimensions.width', '%'),
        // get rid of height in case of Note because of the fixed font size and the dimensions expressed in %
        // - causes in most cases the text to be truncated
        // - a better solution would be to use relative sizing for the font as well, but that involves a deeper change
        //   in player code
        height: areaType === 'note' ? 'auto' : concatIfExists(raw, 'style.dimensions.height', '%'),
        border: concatIfExists(raw, 'style.default.border.width', 'px solid ') + get(raw, 'style.default.border.color'),
        background: get(raw, 'style.default.background.color'),
        position: {
          top: get(raw, 'style.origin.top'),
          left: get(raw, 'style.origin.left')
        },
        text: {
          // the player resets line height to an unreadable size (1em), which results in lines overlapping each other
          // change is backwards compatible
          lineHeight: 'initial',
          fontFamily: get(raw, 'style.default.font.family', 'arial, helvetica, sans-serif'),
          size: concatIfExists(raw, 'style.default.font.size', 'px'),
          underline: false,
          color: get(raw, 'style.default.font.color')
        },
        hover: {
          text: {
            lineHeight: 'initial',
            fontFamily: get(raw, 'style.hover.font.family', 'arial, helvetica, sans-serif'),
            size: concatIfExists(raw, 'style.hover.font.size', 'px'),
            underline: false,
            color: get(raw, 'style.hover.font.color')
          },
          border: concatIfExists(raw, 'style.hover.border.width', 'px solid ') + get(raw, 'style.hover.border.color'),
          background: get(raw, 'style.hover.background.color')
        }
      },
      area: {
        type: areaType,
        text: get(raw, 'area.text', ''),
        position: 'top',
        imageUrl: get(raw, 'style.default.background.url'),
        hoverImageUrl: get(raw, 'style.hover.background.url'),
        withMargin: false
      },
      actionType: actionType,
      action: {
        action: subAction,
        autoTrigger: get(raw, 'startAction') === 'pause',
        additionalAction: null, // QPD does not support this yet
        offset: get(raw, 'action.timeIndex'),
        hrefmailto: get(raw, 'action.hrefmailto'),
        link: get(raw, 'action.link'),
        target: get(raw, 'action.target'),
        videoId: get(raw, 'action.videoId'),
        autoplay: get(raw, 'action.autoPlay'),
        mute: get(raw, 'action.mute'),
        startAt: get(raw, 'action.startAt')
      }
    })
  }
}
